const s = (e, t) => Object.fromEntries(
  Object.entries(e).filter(([r]) => !t.includes(r))
);
export {
  s as default
};
